import React from "react";

/** LazyPageShell provides footer + optional HomeDepthCta for all wrapped routes. */
export const JstShellContext = React.createContext({
  showDepthCta: false,
  shellProvidesFooter: false,
});
